/**
 * Utilitários de CPF.
 *
 * O login da aplicação é feito por CPF (regra preservada do sistema
 * legado), mas o Supabase Auth exige um e-mail como identidade de conta.
 * A partir da Fase 4 (Segurança e Autenticação), a identidade de Auth de
 * cada conta é o e-mail REAL da pessoa (guardado em `perfis.email`) — o
 * frontend traduz CPF -> e-mail real via RPC (`authService.buscarEmailReal`)
 * antes de autenticar, então o CPF nunca é usado diretamente como e-mail.
 *
 * Histórico: versões anteriores geravam um e-mail técnico sintético a
 * partir do CPF (`cpfParaEmailTecnico`). Essa função foi removida por não
 * ser mais utilizada — a migration 0012 corrigiu as contas antigas para
 * usar e-mail real, e a migration 0011 criou a tradução via banco.
 */

/** Remove tudo que não for dígito (pontos, traços, espaços). */
export function sanitizarCpf(cpfComMascara: string): string {
  return cpfComMascara.replace(/\D/g, "");
}

/** Validação estrutural simples (11 dígitos, não todos iguais). Não calcula DV. */
export function cpfEhValido(cpf: string): boolean {
  const limpo = sanitizarCpf(cpf);
  if (limpo.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(limpo)) return false;
  return true;
}

/** Formata um CPF puro (11 dígitos) como "000.000.000-00" para exibição. */
export function formatarCpf(cpf: string): string {
  const limpo = sanitizarCpf(cpf);
  if (limpo.length !== 11) return cpf;
  return limpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}
